/**
 * Fixed schoolyear period → month mapping.
 * A schoolyear spans two calendar years (e.g. 2026-2027):
 * - Periods 1–2 fall in the start year
 * - Periods 3–4 fall in the end year
 * July is not part of any period.
 */
export const SCHOOLYEAR_PERIODS = [
	{
		periode_id: 1,
		name: "Periode 1",
		month_from: 8,
		month_to: 9,
		months: [8, 9],
		label: "August till September",
		label_nl: "Augustus t/m September",
		year_offset: 0
	},
	{
		periode_id: 2,
		name: "Periode 2",
		month_from: 10,
		month_to: 12,
		months: [10, 11, 12],
		label: "October till December",
		label_nl: "Oktober t/m December",
		year_offset: 0
	},
	{
		periode_id: 3,
		name: "Periode 3",
		month_from: 1,
		month_to: 3,
		months: [1, 2, 3],
		label: "January till March",
		label_nl: "Januari t/m Maart",
		year_offset: 1
	},
	{
		periode_id: 4,
		name: "Periode 4",
		month_from: 4,
		month_to: 6,
		months: [4, 5, 6],
		label: "April till June",
		label_nl: "April t/m Juni",
		year_offset: 1
	}
];

const MONTH_NAMES_NL = {
	1: "Januari",
	2: "Februari",
	3: "Maart",
	4: "April",
	5: "Mei",
	6: "Juni",
	7: "Juli",
	8: "Augustus",
	9: "September",
	10: "Oktober",
	11: "November",
	12: "December"
};

/**
 * Parse start/end calendar years from a schoolyear name like "2026-2027".
 * Falls back to nulls when the name cannot be parsed.
 */
export function parseSchoolyearYears(name) {
	if (name == null || typeof name !== "string") {
		return { startYear: null, endYear: null };
	}
	var match = name.trim().match(/^(\d{4})\s*[-/]\s*(\d{4})$/);
	if (!match) {
		return { startYear: null, endYear: null };
	}
	return {
		startYear: Number(match[1]),
		endYear: Number(match[2])
	};
}

export function monthNameNl(month) {
	return MONTH_NAMES_NL[Number(month)] || String(month);
}

/**
 * Build the four periods for a schoolyear, with concrete calendar years when known.
 */
export function periodsForSchoolyear(schoolyear) {
	var name = schoolyear && schoolyear.name != null ? schoolyear.name : "";
	var years = parseSchoolyearYears(name);
	return SCHOOLYEAR_PERIODS.map(function(period) {
		var calendarYear = null;
		if (years.startYear != null) {
			calendarYear =
				period.year_offset === 0 ? years.startYear : years.endYear;
		}
		return {
			periode_id: period.periode_id,
			name: period.name,
			months: period.months.slice(),
			month_from: period.month_from,
			month_to: period.month_to,
			label: period.label,
			label_nl: period.label_nl,
			year_offset: period.year_offset,
			calendar_year: calendarYear,
			months_label: period.months
				.map(function(m) {
					return monthNameNl(m);
				})
				.join(", "),
			range_label: calendarYear
				? period.label_nl + " " + calendarYear
				: period.label_nl
		};
	});
}
